import React, { useEffect, useState } from "react";

import { Divider } from "@mui/material";
import HospitalTimings from "../HomeHospital/HospitalTimings";
import { ILocationContentfulData } from "../../services/contentful-service/contentful.interface";
import { ILocationItemResponse } from "../../services/edit-hospital-location/edit-hospital-location.interface";
import MapMini from "../MapMini/MapMini";
import UserMailIcon from "../Icons/UserMailIcon";
import UserPhoneIcon from "../Icons/UserPhoneIcon";
import { getHospitalTimingArray } from "../../utils/genericUtils";
import { getLocationDetails } from "../../services/contentful-service/contentfulClient.service";
import { getContactString } from "../../shared/containers/ChangeHospitalContainer/ChangeHospitalContainer";
import HospitalCardTimeSlots from "../AvailableTimeSlots/HospitalCardTimeSlots";

interface IHospitalCard{
  hospitalDetails: ILocationItemResponse;
  isHomeHospital?: boolean;
  onCardSelect?: (data: ILocationItemResponse) => void;
  isDisplayedInModal?: boolean;
  displayedModalType?: "previewModal" | "confirmationModal";
}

const HospitalCard = ({
  hospitalDetails,
  isHomeHospital=false,
  onCardSelect,
  isDisplayedInModal,
  displayedModalType,
}: IHospitalCard) =>{
  const [hospitalScheduleDetails, setHospitalScheduleDetails] = useState<ILocationContentfulData | null>(null);


  useEffect(() => {
    getLocationDetails(hospitalDetails.locationName)
      .then((loactionData: ILocationContentfulData | null) => {
        setHospitalScheduleDetails(loactionData);
      });
  }, []);

  const handleCardClick = () => {
    if (onCardSelect && !isHomeHospital ) {
      onCardSelect(hospitalDetails);
    }
  };

  return (
    <div
      className={`bg-white flex flex-col items-center rounded-lg ${isDisplayedInModal ? "" : "border-2"}
    border-taupe-2 cursor-pointer`}
      onClick={handleCardClick}
    >
      <div className="relative w-full">
        {!isDisplayedInModal && !isHomeHospital &&
        <p className="opacity-0 hover:opacity-100 text-white absolute w-full h-full bg-black bg-opacity-30
        flex items-center justify-center">Select Hospital</p>}
        <img src={hospitalDetails.background} className="object-cover h-52 w-full rounded-t-lg" />
      </div>
      <div className="p-5 w-full flex flex-col gap-4">
        <div className="flex flex-col gap-2">
          {isHomeHospital && !isDisplayedInModal &&
          <div className="text-xs text-gv-gold font-semibold">Your Home Hospital</div>}
          <div className="text-2xl capitalize grenette-pro font-semibold">{hospitalDetails.locationName}</div>
          <div className="text-xs font-semibold">{hospitalDetails.address}</div>
        </div>
        <Divider sx={{ opacity: 1 }} />
        <div className="flex flex-col gap-3">
          <div className="text-sm text-gray-1 font-semibold">Hospital Contact</div>
          <a href={`mailto:${hospitalDetails.email}`}>
            <div className="text-sm font-semibold flex gap-4">
              <UserMailIcon width = {20} height = {19} />
              {hospitalDetails.email}
            </div>
          </a>
          <a href={getContactString(hospitalDetails.phoneNumber)}>
            <div className="text-sm font-semibold flex gap-4">
              <UserPhoneIcon width = {20} height = {19} />
              {hospitalDetails.phoneNumber}
            </div>
          </a>
          {isDisplayedInModal && displayedModalType === "confirmationModal" &&
          <MapMini lat={hospitalDetails.position.lat} lng={hospitalDetails.position.lng} height="10rem" />}
          {isDisplayedInModal &&
          <>
            {displayedModalType === "previewModal" &&
              <div>
                <Divider sx={{ opacity: 1 }} />
                <div className="text-sm my-2 text-gray-1 font-semibold">Preview Availability</div>
                <HospitalCardTimeSlots title="Available times" isSelectable={false} isPreviewModal={true} />
                <Divider sx={{ opacity: 1 }} />
              </div>
            }
            <div>
              <HospitalTimings
                timings={hospitalScheduleDetails && hospitalScheduleDetails.fields.schedule ?
                  getHospitalTimingArray(hospitalScheduleDetails.fields.schedule as Array<string>) :
                  []}
              />
            </div>
          </>}
        </div>
      </div>
    </div>
  );
};

export default HospitalCard;
